import React, { useContext, useEffect, useState } from "react";
import SessionContext from "SessionContext";
import ErrorContext from "ErrorContext";
import { useHistory } from "react-router-dom";
import FormatDateTime from "../core/utils/FormatDateTime";
import JsonFormattedDisplay from "../partials/json-formatted-display";

export default function ErrorLogDetails(props) {
  const session = useContext(SessionContext);
  const errorsContext = useContext(ErrorContext);
  const history = useHistory();

  const [loaded, setLoaded] = useState(false);
  const [errorDetails, setErrorDetails] = useState(null);

  function getErrorDetails(_id) {
    session
      .query(`admin/error_details/${_id}`, {})
      .then((response) => {
        setErrorDetails(response);
        setLoaded(true);
      })
      .catch((error) => {
        errorsContext.addMessage("Failed to get error log details", error);
        console.log(JSON.stringify(error));
        setLoaded(true);
      });
  }

  useEffect(() => {
    if (props.args.error_id) {
      getErrorDetails(props.args.error_id);
    } else {
      getErrorDetails(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="page admin-page">
      <div className="list-header sticky-page-header">
        <button className="new-button" onClick={() => history.push("/admin-error-logs")}>
          <i className="bi bi-chevron-left"></i> Error Logs
        </button>
        <h1>Error Details</h1>
        <i className="spacer" />
      </div>
      <div className="invoice-categories">
        {!loaded && <p>Loading...</p>}
        {(loaded && errorDetails) && <DisplayErrorDetails errorDetails={errorDetails} />}
        {(loaded && !errorDetails) && <div>Could Not Load Error Details</div>}
      </div>
    </div>
  );
}

const DisplayErrorDetails = ({ errorDetails }) => {

  return (
    <div className="m-5">
      <table className="table table-bordered error-details-table">
        <tbody>
          <tr>
            <th>User</th>
            <td>{errorDetails.user.first_name} {errorDetails.user.last_name}</td>
          </tr>
          <tr>
            <th>Company</th>
            <td>{errorDetails.company.name}</td>
          </tr>
          <tr>
            <th>Error Time</th>
            <td><FormatDateTime date={errorDetails.error_timestamp} /></td>
          </tr>
          <tr>
            <th>Call Time</th>
            <td><FormatDateTime date={errorDetails.call_timestamp} /></td>
          </tr>
          <tr>
            <th>API Called</th>
            <td>{errorDetails.api_called}</td>
          </tr>
          <tr>
            <th>Response Code</th>
            <td>{errorDetails.response_code}</td>
          </tr>
          <tr>
            <th>Response Text</th>
            <td>{errorDetails.response_text}</td>
          </tr>
          <tr>
            <th>Payload of Call (JSON Object)</th>
            <td><JsonFormattedDisplay data={errorDetails.payload} /></td>
          </tr>
          <tr>
            <th>Error Returned</th>
            <td>{errorDetails.error_returned || "N/A"}</td>
          </tr>
          <tr>
            <th>API Health Report</th>
            <td><JsonFormattedDisplay data={errorDetails.api_health} /></td>
          </tr>
        </tbody>
      </table>
    </div>

  )
}